/**
 * @flow
 * @relayHash 537ff33262f0695377b7a602210a6ddf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PhoneProvidersQueryVariables = {||};
export type PhoneProvidersQueryResponse = {|
  +phone_providers: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +ref_id: string,
  |}>
|};
export type PhoneProvidersQuery = {|
  variables: PhoneProvidersQueryVariables,
  response: PhoneProvidersQueryResponse,
|};
*/


/*
query PhoneProvidersQuery {
  phone_providers {
    id
    name
    ref_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "phone_providers",
    "storageKey": null,
    "args": null,
    "concreteType": "PhoneProvider",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "PhoneProvidersQuery",
  "id": null,
  "text": "query PhoneProvidersQuery {\n  phone_providers {\n    id\n    name\n    ref_id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PhoneProvidersQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "PhoneProvidersQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e93ea5bb1adec630e0b1034b019e36c1';
module.exports = node;
